const messages = {
  start: {
    id: 'admin/promotions.form.file-upload.status.start',
  },
  error: { id: 'admin/promotions.form.file-upload.error' },
  success: {
    id: 'admin/promotions.form.file-upload.success',
  },
  upload: {
    id: 'admin/promotions.utils.upload',
  },
  validation: {
    listMaxSize: {
      id: 'admin/promotions.form.file-upload.validation.list.max-size',
    },
    noValidEntries: {
      id: 'admin/promotions.form.file-upload.validation.file.no-valid-entries',
    },
    invalidEntries: {
      id: 'admin/promotions.form.file-upload.validation.file.invalid-entries',
    },
  },
}

export default messages
